module.exports = __webpack_public_path__ + "static/img/logo.482d1724.png";